import { render, staticRenderFns } from "./Scale.vue?vue&type=template&id=0c4d8320&scoped=true&"
import script from "./Scale.vue?vue&type=script&lang=js&"
export * from "./Scale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d8320",
  null
  
)

export default component.exports